(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-bed-transformation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lullor-before-after')) {
    class LullorBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('input[type="range"]');
        if (!this.range) return;
        this.updatePosition = () => {
          this.style.setProperty('--comparison-position', `${this.range.value}%`);
        };
        this.range.addEventListener('input', this.updatePosition);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (this.range && this.updatePosition) {
          this.range.removeEventListener('input', this.updatePosition);
        }
      }
    }

    customElements.define('lullor-before-after', LullorBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-cart-count')) {
    customElements.define('home-cart-count', class extends HTMLElement {
      connectedCallback() {
        this.refresh = async () => { try { const response = await fetch(this.dataset.url, { headers: { Accept: 'application/json' } }); if (response.ok) this.textContent = (await response.json()).item_count; } catch (error) {} };
        this.events = ['cart:updated', 'cart:update', 'cart-update', 'cartUpdate', 'lullor:cart-updated'];
        this.events.forEach((name) => document.addEventListener(name, this.refresh));
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
        }
        this.onSubmit = (event) => { if (event.target.matches('form[action*="/cart/add"]')) { setTimeout(this.refresh, 500); setTimeout(this.refresh, 1500); } };
        document.addEventListener('submit', this.onSubmit, true);
        window.addEventListener('pageshow', this.refresh);
      }
      disconnectedCallback() { this.events?.forEach((name) => document.removeEventListener(name, this.refresh)); this.unsubscribeCartUpdate?.(); document.removeEventListener('submit', this.onSubmit, true); window.removeEventListener('pageshow', this.refresh); }
    });
  }
  const initHomeMenus = (scope = document) => scope.querySelectorAll('[data-hv4-menu]').forEach((menu) => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const summary = menu.querySelector('summary');
    const close = (restoreFocus = false) => { if (!menu.open) return; menu.removeAttribute('open'); if (restoreFocus) summary?.focus(); };
    summary?.addEventListener('pointerdown', () => { menu.dataset.keyboardOpen = 'false'; });
    summary?.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') menu.dataset.keyboardOpen = 'true'; });
    menu.addEventListener('toggle', () => {
      summary?.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
      if (menu.open && menu.dataset.keyboardOpen === 'true') requestAnimationFrame(() => menu.querySelector('nav a')?.focus());
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close()));
    menu.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(true); });
    document.addEventListener('pointerdown', (event) => { if (!menu.contains(event.target)) close(); });
  });
  initHomeMenus();
  document.addEventListener('shopify:section:load', (event) => initHomeMenus(event.target));
  const initAnnouncementBars = (scope = document) => scope.querySelectorAll('[data-hv4-announcement]').forEach((bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const button = bar.querySelector('[data-hv4-announcement-pause]');
    const icon = bar.querySelector('[data-hv4-announcement-icon]');
    button?.addEventListener('click', () => {
      const paused = bar.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      button.setAttribute('aria-label', paused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
      if (icon) icon.textContent = paused ? '▶' : 'Ⅱ';
    });
  });
  initAnnouncementBars();
  document.addEventListener('shopify:section:load', (event) => initAnnouncementBars(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-hero')) {
    customElements.define('home-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.index = 0;
        this.pointerInside = false;
        this.focusInside = false;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.go))));
        this.addEventListener('mouseenter', () => { this.pointerInside = true; this.stop(); });
        this.addEventListener('mouseleave', () => { this.pointerInside = false; if (!this.focusInside) this.start(); });
        this.addEventListener('focusin', () => { this.focusInside = true; this.stop(); });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && this.contains(event.relatedTarget)) return;
          this.focusInside = false;
          if (!this.pointerInside) this.start();
        });
        this.start();
      }
      show(next) {
        if (!this.slides.length) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => { const active = index === this.index; slide.hidden = !active; slide.classList.toggle('is-active', active); });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
      }
      start() { if (this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return; this.stop(); this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 6000); }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-review-carousel')) {
    customElements.define('home-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        this.controls = this.querySelector('[data-review-controls]');
        this.cards = [...this.track.querySelectorAll('.hv4-review-card')];
        this.onScroll = () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
        this.build();
      }
      build() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const firstLeft = this.cards[0]?.offsetLeft || 0;
        this.positions = this.cards
          .map((card) => Math.min(max, Math.max(0, card.offsetLeft - firstLeft)))
          .filter((position, index, positions) => index === 0 || Math.abs(position - positions[index - 1]) > 2);
        this.controls.replaceChildren();
        if (max <= 2 || this.positions.length < 2) {
          this.controls.hidden = true;
          return;
        }
        this.controls.hidden = false;
        this.positions.forEach((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hv4-review-dot';
          button.setAttribute('aria-label', `${this.controls.dataset.label} ${index + 1}`);
          button.setAttribute('aria-controls', this.track.id);
          button.addEventListener('click', () => this.track.scrollTo({ left: position, behavior: 'smooth' }));
          this.controls.append(button);
        });
        this.update();
      }
      update() {
        if (!this.positions?.length) return;
        let active = 0;
        this.positions.forEach((position, index) => {
          if (Math.abs(this.track.scrollLeft - position) < Math.abs(this.track.scrollLeft - this.positions[active])) active = index;
        });
        [...this.controls.children].forEach((button, index) => button.setAttribute('aria-current', index === active ? 'true' : 'false'));
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-proof"] && !Shopify.designMode) return;
  try {
    
const initProofVideos = (root = document) => {
  root.querySelectorAll('.lp-proof__media video').forEach(video => {
    if (video.dataset.proofReady) return;
    video.dataset.proofReady = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.tabIndex = 0;
    video.setAttribute('role', 'button');
    video.setAttribute('aria-label', video.closest('article').querySelector('h3').textContent);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = reduced.matches;
    const sync = () => video.setAttribute('aria-pressed', String(!video.paused));
    const toggle = () => {
      userPaused = !video.paused;
      if (video.paused) video.play().catch(() => {}); else video.pause();
    };
    video.addEventListener('click', toggle);
    video.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); toggle(); }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    reduced.addEventListener('change', () => {
      userPaused = reduced.matches;
      if (userPaused) video.pause();
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !userPaused) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.15 });
    if (reduced.matches) video.pause();
    observer.observe(video);
    sync();
  });
};
initProofVideos();
document.addEventListener('shopify:section:load', event => initProofVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-review-grid"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lullor-review-wall'))customElements.define('lullor-review-wall',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const cards=[...this.querySelectorAll('.lr-wall__card')],button=this.querySelector('button');let shown=12;if(window.Shopify&&Shopify.designMode)return;const update=()=>{cards.forEach((card,i)=>card.hidden=i>=shown);button.hidden=shown>=cards.length;};update();button.addEventListener('click',()=>{const first=cards[shown];shown+=12;update();if(first){first.tabIndex=-1;first.focus({preventScroll:true});}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lullor-reviews'))customElements.define('lullor-reviews',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const b=e.target.closest('[data-direction]');if(!b)return;const t=this.querySelector('.ll-review-track');t.scrollBy({left:Number(b.dataset.direction)*(t.querySelector('article').getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-sleep-proof"] && !Shopify.designMode) return;
  try {
    
const initProofVideos = (root = document) => {
  root.querySelectorAll('.lp-proof__media video').forEach(video => {
    if (video.dataset.proofReady) return;
    video.dataset.proofReady = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.tabIndex = 0;
    video.setAttribute('role', 'button');
    video.setAttribute('aria-label', video.closest('article').querySelector('h3').textContent);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = reduced.matches;
    const sync = () => video.setAttribute('aria-pressed', String(!video.paused));
    const toggle = () => {
      userPaused = !video.paused;
      if (video.paused) video.play().catch(() => {}); else video.pause();
    };
    video.addEventListener('click', toggle);
    video.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); toggle(); }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    reduced.addEventListener('change', () => {
      userPaused = reduced.matches;
      if (userPaused) video.pause();
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !userPaused) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.15 });
    if (reduced.matches) video.pause();
    observer.observe(video);
    sync();
  });
};
initProofVideos();
document.addEventListener('shopify:section:load', event => initProofVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lullor-sleep-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lullor-review-wall'))customElements.define('lullor-review-wall',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const cards=[...this.querySelectorAll('.lr-wall__card')],button=this.querySelector('button');let shown=12;if(window.Shopify&&Shopify.designMode)return;const update=()=>{cards.forEach((card,i)=>card.hidden=i>=shown);button.hidden=shown>=cards.length;};update();button.addEventListener('click',()=>{const first=cards[shown];shown+=12;update();if(first){first.tabIndex=-1;first.focus({preventScroll:true});}});}});

  } catch(e) { console.error(e); }
})();
})();
